import { createTRPCReact } from '@trpc/react-query';
import { httpBatchLink } from '@trpc/client';
import type { AppRouter } from 'server/routers';

/**
 * tRPC React client
 *
 * Usage:
 * - trpc.contact.getById.useQuery({ id })
 * - trpc.appointment.create.useMutation()
 */
export const trpc = createTRPCReact<AppRouter>();

/**
 * tRPC client instance
 * Uses credentials: 'include' so the httpOnly auth cookie is sent automatically.
 */
export const trpcClient = trpc.createClient({
  links: [
    httpBatchLink({
      url: '/trpc',
      fetch(url, options) {
        return fetch(url, { ...options, credentials: 'include' });
      },
    }),
  ],
});
